<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            Dashboard
          </h3>
        </div>
      </div>
    </div>

    <div class="content">
      <template v-if="lastProjects && lastProjects.length !== 0">
        <div class="row" v-if="lastProjects">
          <div class="col-lg-12" id="recently-projects">
            <div class="hpanel">
              <div class="panel-heading">
                Recently active projects
                <div class="panel-tools">
                  <button class="btn btn-xs btn-info " @click="modalProjectAction = 'create'"><i class="fa fa-plus"></i> New Project</button>
                </div>
              </div>
              <div class="panel-body list no-padding">
                <recently-projects :projects="lastProjects"></recently-projects>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-lg-3" id="project-by-workflows">
            <div class="hpanel">
              <div class="panel-heading">
                Projects by workflow
              </div>
              <div class="panel-body">
                <project-by-workflow v-if="workflows" :workflows="workflows" :height="320"></project-by-workflow>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-lg-3" id="project-by-status">
            <div class="hpanel">
              <div class="panel-heading">
                Projects by Status
              </div>
              <div class="panel-body">
                <project-by-status v-if="projectsStatus" :projectsStatus="projectsStatus" :height="320"></project-by-status>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-lg-3" id="radar-innovation">
            <div class="hpanel">
              <div class="panel-heading">
                <i class="fa fa-info-circle text-info" data-toggle="popover" :data-content="radarHelp"></i> Open Innovation Profile - <a href="https://academy.idexlab.com/hc/en-us/articles/360014934299-What-is-the-Open-Innovation-Score-" target="_blank">Learn more</a>
              </div>
              <div class="panel-body">
                <idx-radar v-if="radar" :stats="radar" :height="320"></idx-radar>
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-lg-3" id="innovation-score">
            <div class="hpanel">
              <div class="panel-heading">
                Open Innovation Score - <a href="https://academy.idexlab.com/hc/en-us/articles/360022053839-User-levels" target="_blank">Learn more</a>
              </div>
              <div class="panel-body">
                <OIScore v-if="OIScore" :OIScore="OIScore" :height="320"></OIScore>
              </div>
            </div>
          </div>

        </div>
      </template>
      <template v-else>
        <div class="row" >
          <div style="margin-top: 60px;height: 200px">
            <div class="col-xs-12 text-center">
              <h4>Click the button below to start your first project</h4>
            </div>
            <div class="col-xs-12 text-center" style="margin-top: 30px">
              <button class="btn btn-info" id="first-project" @click="modalProjectAction = 'create'">Create My First Project</button>
            </div>
            <div class="col-xs-12 text-center" style="margin-top: 30px">
              <template v-if="$user.isSe()">
                <h5>watch the 2mn <a href="https://schneider-electric.box.com/s/1qy85yoj5nv3ffaep2ginzzvg8hg4nyx" target="_blank" class="text-info">video</a></h5>
              </template>
              <template v-else>
                <h5>watch the 2mn <a href="https://www.youtube.com/watch?v=VAXa9WlPvTo" target="_blank" class="text-info">intro to the platform</a></h5>
              </template>
            </div>

          </div>
        </div>
      </template>
       <div class="row">
        <div class="col-xs-12">
          <followed-queries :show-limit-plan="showLimitPlan"></followed-queries>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12" id="last-notifications">
          <div class="hpanel">
            <div class="panel-heading">
              Last notifications
            </div>
            <div class="panel-body list no-padding">
              <recently-notifications></recently-notifications>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-4" id="account-history">
          <div  class="hpanel stats">
            <div class="panel-body h-200 text-center">
              <div class="small">
                <i  class="fa fa-clock-o"></i> Active for
              </div>
              <div class="text-info">
                <h1  class="font-extra-bold m-t-lg m-b-xs">  {{activeFrom[0]}}</h1> <small >And {{activeFrom[1]}}</small>
              </div>
              <div class="small m-t-lg">
                <i class="fa fa-clock-o"></i> {{lastLogin}}
              </div>
            </div>
            <div  class="panel-footer"><i class="fa fa-laptop"></i> Account History</div>
          </div>
        </div>

        <div class="col-sm-12 col-md-4" id="attached-account">
          <div class="hpanel stats">
            <div class="panel-body h-200">
              <div class="stats-title pull-left">
                <h4>Attached Account</h4>
              </div>
              <div class="stats-icon pull-right text-info">
                <i class="pe-7s-share fa-4x"></i>
              </div>
              <div class="m-t-xl" >
                <h5 class="m-b-xs" v-if="attachedTo"><a v-bind:href="'mailto:'+attachedTo.email" class="text-primary">{{attachedTo.firstname}} {{attachedTo.lastname}}</a></h5>
                <h5 class="m-b-xs" v-else>Empty</h5>
                <hr>
                <div class="row">
                  <div class="col-xs-12">
                    <div class="stats-title pull-left">
                      <h4>ideXlab Support</h4>
                    </div>
                    <div class="stats-icon pull-right text-info">
                      <i class="pe-7s-mail fa-4x"></i>
                    </div>
                    <div class="m-t-xl">
                      <h6><a href="mailto:support-idexlab@group-gac.com" class="text-primary">support-idexlab@group-gac.com</a></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-footer">
              <i class="fa fa-info-circle"></i> Personal Account support
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-4" id="infos">
          <div class="hpanel stats">
            <div class="hpanel-body h-200">
              <div class="panel-body no-padding" style="display: block;">
                <ul class="list-group">
                  <li class="list-group-item">
                    <h5><a href="https://www.idexlab.com/about-us/" target="_blank" class="text-primary">About idexlab</a></h5>
                  </li>
                  <li class="list-group-item">
                    <h5><a href="https://www.idexlab.com/open-innovation-academy/" target="_blank" class="text-primary">Academy</a></h5>
                  </li>
                  <li class="list-group-item">
                    <h5><a href="https://academy.idexlab.com/hc/en-us/categories/360000644600-FAQ" target="_blank" class="text-primary">Common questions</a></h5>
                  </li>
                  <li class="list-group-item">
                    <h5><a href="https://www.idexlab.com/webinar-idexlab-platform-demo/" target="_blank" class="text-primary">Training Webinar</a></h5>
                  </li>
                  <li class="list-group-item">
                    <h5><a href="https://blog.idexlab.com" target="_blank" class="text-primary">Blog</a></h5>
                  </li>
                </ul>
              </div>
            </div>
            <div class="panel-footer"><i class="fa fa-question-circle"></i> Help Center</div>
          </div>
        </div>

      </div>

      <template v-if="modalProjectAction !== null">
        <action-modal-project :project="null" :portfolio="null" v-model="modalProjectAction"/>
      </template>
    </div>

    <limit-plan ref="limitPlan"></limit-plan>
  </div>
</template>

<style scoped>
  body.light-skin .hpanel>.panel-footer, body.light-skin .hpanel>.panel-section {
    border: 1px solid #eaeaea;
    border-top: 0;
  }
  .hpanel.stats .list-group-item {
    padding:7px 15px;
  }
</style>

<script>
import ActionModalProject from '../../components/project/ActionModalProject'
import Summernote from '../../components/utils/Summernote'
import OIScore from '../../components/charts/OIScore'
import RecentlyNotifications from '../../components/notification/RecentlyNotifications'
import RecentlyProjects from '../../components/project/RecentlyProjects'
import IdxRadar, {info as radarHelp} from '../../components/charts/IdxRadar'
import ProjectByStatus from '../../components/charts/ProjectByStatus'
import ProjectByWorkflow from '../../components/charts/ProjectByWorkflow'
import VueLadda from 'vue-ladda'
import FollowedQueries from '../../components/Dashboard/FollowedQueries'
import LimitPlan from '../../components/LimitPlan'

export default {
  name: 'Dashboard',
  components: {
    LimitPlan,
    FollowedQueries,
    ActionModalProject,
    Summernote,
    OIScore,
    RecentlyNotifications,
    RecentlyProjects,
    IdxRadar,
    ProjectByStatus,
    ProjectByWorkflow,
    VueLadda
  },
  data () {
    return {
      workflows: null,
      projectsStatus: null,
      radar: null,
      radarHelp,
      OIScore: null,
      attachedTo: null,
      activeFrom: ['-- Months', ' -- Weeks' ],
      lastLogin: null,
      lastProjects: [],
      summaryNotes: '',
      modalProjectAction: null,
      save: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  watch: {
    lastProjects: function (val) {
      if (val !== null && val.length !== 0) {
        this.$route.meta.empty = false
      } else {
        this.$route.meta.empty = true
      }
    }
  },
  methods: {
    getResources: function () {
      this.getLoginHistory()
      this.getDashboardDatas()
    },
    getLoginHistory: function () {
      this.axios.get('/dashboard/login')
        .then((response) => {
          let loginHistoryDatas = response.data.data
          if (loginHistoryDatas.attachedTo) {
            this.attachedTo = loginHistoryDatas.attachedTo
          }
          this.lastLogin = loginHistoryDatas.lastLogin
          this.activeFrom = this.parseActiveDuration(loginHistoryDatas.activeFrom)
        })
        .catch(function (error) {
        })
    },
    saveSummaryNotes: function () {
      this.save.loading = true

      this.axios.patch('/dashboard/summaryNotes', {
        summaryNotes: this.summaryNotes
      })
        .then((response) => {
          this.$notify({
            type: 'success',
            title: 'Notes saved',
            placement: 'bottom-right'
          })
        })
        .finally(() => {
          this.save.loading = false
        })
    },
    getDashboardDatas: function () {
      this.axios.get('/dashboard')
        .then((response) => {
          this.lastProjects = response.data.last_projects

          this.workflows = response.data.workflow
          this.projectsStatus = response.data.projects_status
          this.radar = response.data.radar
          this.OIScore = response.data.oi_score
          this.$salesMachine.setOpenInnovationScore(this.OIScore)
          this.$eventHub.$emit('startTour', true)
        })
        .catch(function (error) {
        })
    },
    parseActiveDuration: function (activeFrom) {
      // TODO: to use temp table for seconde column
      let temp = [ '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen' ]
      if (activeFrom.Y) {
        return [ activeFrom.Y + ' Years', activeFrom.M + ' Months' ]
      } else if (activeFrom.M) {
        return [ activeFrom.M + ' Months', activeFrom.D + ' Days' ]
      } else if (activeFrom.D) {
        return [ activeFrom.D + ' Days', activeFrom.H + ' Hours' ]
      } else {
        return [ activeFrom.H + ' Hours', activeFrom.i + ' Minutes' ]
      }
    },
    showLimitPlan: function (action) {
      this.$refs.limitPlan.show(action)
    }
  },
  updated () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      placement: 'top',
      html: true
    })
  },
  mounted () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Dashboard.vue